import React from "react";
import {twMerge} from "tailwind-merge";
import AudioPlayer from "../audio-player";
import {CommonIcon} from "../icon";
import RenderIf from "../render-if";

const FileView = ({
  url,
  mime = "",
  contents = "",
  className,
  iconClassName,
  fileClassName,
  imageClassName,
  controls = true,
  thumbnail,
}) => {
  const onError = (event) => {
    event.currentTarget.src = "/images/game-cover.png";
  };

  return (
    <>
      <RenderIf cond={mime.startsWith("image")}>
        <img
          src={thumbnail ?? url}
          alt="cover"
          className={twMerge("aspect-4/3 h-full w-full object-cover", className, imageClassName)}
          onError={onError}
        />
      </RenderIf>
      <RenderIf cond={mime.startsWith("video")}>
        <video
          src={url}
          autoPlay={false}
          controls={true}
          className={twMerge("aspect-video h-full w-full bg-black object-contain", className)}
        />
      </RenderIf>
      <RenderIf cond={mime.startsWith("text/uri-list") && contents?.search("arvan") !== -1}>
        <div className={twMerge("flex aspect-video h-full w-full items-center justify-center bg-black", className)}>
          <iframe
            className={twMerge("h-full w-full", className)}
            id="ir1p"
            title="arvan"
            src={`https://player.arvancloud.ir/?config=${contents}`}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </RenderIf>
      <RenderIf cond={mime.startsWith("application")}>
        <a
          target="_blank"
          href={url}
          className={twMerge(
            "bg-primary-light flex aspect-4/3 items-center justify-center p-2",
            className,
            fileClassName
          )}
        >
          <CommonIcon icon="document" className={iconClassName} />
        </a>
      </RenderIf>
      <RenderIf cond={mime.startsWith("audio")}>
        <div className={twMerge("bg-primary-light flex flex-col justify-center gap-1.5 p-4", className)}>
          <AudioPlayer source={url} controls={controls} />
        </div>
      </RenderIf>
    </>
  );
};

export default FileView;
